import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaBell, FaList, FaCalendarAlt, FaFileAlt, 
  FaHeadset, FaIdCard, FaCog, FaChevronRight, FaCalculator 
} from 'react-icons/fa';

const DriverToolsMenu = () => {
    return (
        <>
            <div className="bry-section-header">Herramientas del Conductor</div>
            <div className="bry-menu-list mb-3">
                <Link to="/notificaciones" className="bry-menu-item"><FaBell /> Notificaciones <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/calculadora" className="bry-menu-item"><FaCalculator style={{ color: 'var(--bry-accent)' }} /> Calculadora de Tarifas <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/historial-servicios" className="bry-menu-item"><FaList /> Historial de Servicios <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/turnos" className="bry-menu-item"><FaCalendarAlt /> Mis Turnos <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/documentos" className="bry-menu-item"><FaFileAlt /> Mis Documentos <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/soporte" className="bry-menu-item"><FaHeadset /> Soporte <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/perfil" className="bry-menu-item"><FaIdCard /> Mi Perfil <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                <Link to="/config" className="bry-menu-item"><FaCog /> Configuración <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
            </div>
        </>
    );
};

export default DriverToolsMenu;
